import React from "react";

const HeadingSection = (props) => {

  return (
    <>
      <div className={"sectionHeadingPage overflow-hidden"} style={{ backgroundImage: `url(${process.env.REACT_APP_SITE_URL + (props.data?.image && props.data?.image[0]?.objectUrl)})` }}>

        <div className={"container-fluid text-center w-50"}>
          <h1 className="title-heading white">{props.data?.title ?? ""}</h1>
          <p className="paragraph mt-5">{props?.data?.description ?? ""}</p>
        </div>
        <div className="gradient-overlay-down-full-light"></div>
      </div>
    </>
  );
};

export default HeadingSection;
